import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAdjusterIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 21,
			cy: 21.0039,
			r: 21,
			fill: "#F0EEFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16 20.9961C12 20.9961 12 22.7861 12 24.9961V25.9961C12 28.7561 12 30.9961 17 30.9961H25C29 30.9961 30 28.7561 30 25.9961V24.9961C30 22.7861 30 20.9961 26 20.9961C25 20.9961 24.72 21.2061 24.2 21.5961L23.18 22.6761C22 23.9361 20 23.9361 18.81 22.6761L17.8 21.5961C17.28 21.2061 17 20.9961 16 20.9961Z",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28 20.9961V14.9961C28 12.7861 28 10.9961 24 10.9961H18C14 10.9961 14 12.7861 14 14.9961V20.9961",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeMiterlimit: 10,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5508 18.2261H22.8808",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.7188 15.2261H23.7188",
			stroke: "#7548F0",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgAdjusterIcon;
